import { regex } from '../../node_modules/vuelidate/lib/validators/common'
export default regex('ascii', /[\x20-\x7E]+$/)



// WEBPACK FOOTER //
// ./src/validators/ascii.js